export default __webpack_public_path__ + "assets/488df2a6f527eaf1072f377915e6104b.svg";